import { createContext } from "react"
import type { CatCustomerRating } from "@/lib/reviews/cat-customer-rating"

// undefined preserves other pages; null hides an unavailable cat-page badge.
export const CatCustomerRatingContext = createContext<
  CatCustomerRating | null | undefined
>(undefined)
